function ArrowLeft({color, size = 22}: {color?: string; size?: number}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2361 3.63886C14.5046 3.90735 14.5046 4.34265 14.2361 4.61114L7.84727 11L14.2361 17.3889C14.5046 17.6574 14.5046 18.0927 14.2361 18.3611C13.9676 18.6296 13.5323 18.6296 13.2639 18.3611L6.38886 11.4861C6.12038 11.2177 6.12038 10.7823 6.38886 10.5139L13.2639 3.63886C13.5323 3.37038 13.9677 3.37038 14.2361 3.63886Z"
        fill={color || '#666666'}
      />
    </svg>
  );
}

export default ArrowLeft;
